module.exports = __webpack_public_path__ + "img/gaishui.a8a63831.png";